<template>
	<div class="kanban-column-header" @click.stop>
		<span class="column-dot" :style="{ backgroundColor: column.hexColor }"></span>
		<strong>{{ column.label }}</strong>
		<span class="column-count">{{ count }}</span>
		<button
			v-if="allowAddDeliverable"
			type="button"
			:aria-label="$t('projects.add-deliverable')"
			@click.stop="addDeliverable(column)"
		>
			<span aria-hidden="true">+</span>
		</button>
	</div>
</template>

<script>
	export default {
		name: 'KanbanHeader',

		props: {
			column: { type: Object, required: true },
			count: { type: Number, required: false, default: 0 },
			allowAddDeliverable: { type: Boolean, required: false, default: false },
		},

		components: {},

		data: function () {
			return {
			};
		},

		mounted() {},

		methods: {
			addDeliverable: function (column) {
				this.$emit('add-deliverable', column);
			},
		},

	};
</script>

<style scoped lang="scss">
	.kanban-column-header {
		min-height: 47px;
		display: flex;
		align-items: center;
		gap: 8px;
		padding: 9px 10px 8px 12px;
	}

	.column-dot {
		width: 9px;
		height: 9px;
		flex: 0 0 9px;
		border-radius: 999px;
	}

	.kanban-column-header strong {
		min-width: 0;
		flex: 1;
		color: var(--portal-text);
		font-size: 13px;
		font-weight: 750;
		text-align: left;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.column-count {
		padding: 1px 7px;
		border-radius: 999px;
		background: var(--v-gray_30-base);
		color: var(--portal-muted);
		font-size: 11px;
		font-weight: 700;
	}

	button {
		width: 28px;
		height: 28px;
		display: grid;
		place-items: center;
		border: 0;
		border-radius: var(--brand-button-radius, 8px);
		background: transparent;
		color: var(--portal-muted);
		font: inherit;
		font-size: 21px;
		line-height: 1;
		cursor: pointer;
	}

	button:hover {
		background: var(--portal-surface);
		color: var(--portal-text);
	}

	button:focus-visible {
		outline: 2px solid var(--v-primary-base);
		outline-offset: 1px;
	}
</style>
